import { cn } from '~/shared/lib/utils'

const PIN_PATH =
  'M 30,4 C 14,4 4,15 4,28 C 4,40 16,55 24,65 C 27,69 28,71 30,74 C 32,71 33,69 36,65 C 44,55 56,40 56,28 C 56,15 46,4 30,4 Z'

interface PulsifyLoaderProps {
  className?: string
  tone?: 'brand' | 'on-brand'
}

export function PulsifyLoader({ className, tone = 'brand' }: PulsifyLoaderProps) {
  return (
    <svg
      viewBox="0 -10 60 94"
      aria-hidden="true"
      data-tone={tone}
      className={cn('pulsify-loader', className)}
    >
      <ellipse className="pulsify-loader-ring" cx="30" cy="76" rx="16" ry="4" />
      <g className="pulsify-loader-pin">
        <path d={PIN_PATH} />
        <g className="pulsify-loader-eyes">
          <g className="pulsify-loader-glance">
            <g className="pulsify-loader-blink">
              <circle cx="22" cy="25" r="3.8" />
              <circle cx="38" cy="25" r="3.8" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
